import { ErrorMessage } from "@hookform/error-message";
import {
  FC,
  HTMLInputTypeAttribute,
  useEffect,
  useState,
  type RefCallback,
} from "react";
import { Controller, useFormContext } from "react-hook-form";
import CustomErrorMessage from "@/components/forms/inputsWithRef/customErrorMessage";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "@/components/forms/inputs/genericInputField.module.css";
import { MuiTelInput } from 'mui-tel-input';
import { InputWithRef } from "@/components/forms/inputsWithRef/inputWithRef";

interface Props {
  name: string;
  label: string;
  inputType: HTMLInputTypeAttribute;
  predefinedvalue?: any;
  validationTargetRef?: RefCallback<HTMLElement>;
}

const GenericInputField: FC<Props> = ({
  name,
  label,
  inputType,
  predefinedvalue,
  validationTargetRef,
}) => {
  const [inputValue, setInputValue] = useState<any>("");
  const { setValue, control } = useFormContext();
  const { t } = useTranslation();

  useEffect(() => {
    if (predefinedvalue) {
      if (predefinedvalue === null) {
        setInputValue("");
        setValue(name, "");
      } else {
        setInputValue(predefinedvalue);
        setValue(name, predefinedvalue);
      }
    }
  }, [predefinedvalue]);

  const onChangeHandler = (newValue: any, onChange?: any) => {
    const value = newValue.target.value;
    onChange(value);
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, ...rest },
          formState: { errors },
        }) => (
          <>
            {inputType === "tel" ? (
              <div ref={validationTargetRef}>
                <Typography variant="body1" className={styles.phoneInputLabel}>
                  {label}
                </Typography>
                <MuiTelInput
                  placeholder={t("input_your_phone_number")}
                  defaultCountry="DE"
                  langOfCountryName="DE"
                  value={inputValue || ""}
                  onChange={(value: string) => {
                    if (value) {
                      onChange?.(value);
                      setInputValue(value);
                    } else {
                      onChange?.("");
                      setInputValue("");
                    }
                  }}
                  className={styles.fullWidth}
                />
              </div>
            ) : (
              <InputWithRef
                {...rest}
                type={inputType}
                label={label}
                name={name}
                onChange={(event) => {
                  onChangeHandler(event, onChange);
                  setInputValue(event.target.value);
                }}
                className={styles.fullWidth}
                value={inputValue}
              />
            )}
            <ErrorMessage
              errors={errors}
              name={name}
              render={({ message }) => (
                <CustomErrorMessage error={"error"} errorMessage={message} />
              )}
            />
          </>
        )}
      />
    </>
  );
};

export default GenericInputField;
